var _circle, _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhase1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 92,
    viewBox: "0 0 108 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#D11C1C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_204_2418)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 19,
    width: 88,
    height: 73,
    rx: 5,
    fill: "url(#paint0_linear_204_2418)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 19.5,
    width: 87,
    height: 72,
    rx: 4.5,
    stroke: "url(#paint1_linear_204_2418)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.5652 48.8758C52.3295 50.858 51.643 53.163 51.643 55.6523C51.643 62.7976 57.4096 68.6061 64.4577 68.6061C71.5515 68.6061 77.3181 62.7976 77.3181 55.6523C77.3181 48.507 71.5515 42.6985 64.4577 42.6985C61.9863 42.6985 59.6979 43.4361 57.73 44.6347L59.4691 46.3864C60.9336 45.5566 62.6728 45.0957 64.4577 45.0957C70.2243 45.0957 74.9382 49.8438 74.9382 55.6523C74.9382 61.4608 70.2243 66.209 64.4577 66.209C58.6911 66.209 54.0229 61.4608 54.0229 55.6523C54.0229 53.8084 54.4805 52.1027 55.2586 50.6275L53.5652 48.8758ZM58.3249 53.7162C58.1419 54.3154 58.0503 54.9608 58.0503 55.6523C58.0503 59.2019 60.9336 62.1062 64.4577 62.1062C67.9817 62.1062 70.865 59.2019 70.865 55.6523C70.865 52.1027 67.9817 49.1985 64.4577 49.1985C63.7712 49.1985 63.1304 49.2907 62.5355 49.4751L64.595 51.5956C66.7918 51.6417 68.4851 53.4396 68.4851 55.6523C68.4851 57.9112 66.7002 59.7551 64.4577 59.7551C62.2609 59.7551 60.476 58.0034 60.4302 55.7906L58.3249 53.7162ZM47.7071 45.5106C45.9222 48.507 44.9153 51.9644 44.9153 55.6523C44.9153 66.5317 53.7025 75.3826 64.4577 75.3826C75.2586 75.3826 84 66.5317 84 55.6523C84 44.773 75.2586 35.9681 64.4577 35.9681C60.7963 35.9681 57.3638 36.9823 54.4348 38.7801L56.1281 40.5319C58.5995 39.1489 61.4371 38.3652 64.4577 38.3652C73.9314 38.3652 81.6659 46.1098 81.6659 55.6523C81.6659 65.1948 73.9314 72.9855 64.4577 72.9855C54.984 72.9855 47.2952 65.1948 47.2952 55.6523C47.2952 52.6098 48.0732 49.7517 49.4462 47.2623L47.7071 45.5106ZM44 39.2411L47.341 38.4113L48.1648 35L54.4805 41.3616L54.206 43.6205L65.373 54.8686C65.8307 55.3296 65.8307 56.0672 65.373 56.5282C64.9153 57.0353 64.1373 57.0353 63.6796 56.5282L52.5584 45.3262L50.27 45.5566L44 39.2411Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_204_2418",
    x: -5,
    y: -6,
    width: 138,
    height: 123,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_204_2418"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_204_2418",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_204_2418",
    x1: -9.17563,
    y1: -50.6818,
    x2: 61.8865,
    y2: -37.3225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFBFB",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_204_2418",
    x1: 106.029,
    y1: 68.5515,
    x2: 40.0421,
    y2: 63.8705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.31
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhase1);
export default __webpack_public_path__ + "static/media/Phase 1.69e2c4f67b23b78146a80d45604ab2de.svg";
export { ForwardRef as ReactComponent };